import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { Accordion } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { getIntuneAccordionDefaultActiveKeys } from '../intuneAccordionDefaults'
import { getAccordionEventKeysFromChildren } from '../intuneAccordionUtils'
import accordionStyles from './IntuneEditFormAccordion.module.scss'

const accordionPropTypes = {
  children: PropTypes.node,
  defaultActiveKey: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  activeKey: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  onSelect: PropTypes.func,
  alwaysOpen: PropTypes.bool,
}

function IntuneEditFormAccordion({
  children = null,
  defaultActiveKey,
  activeKey = undefined,
  onSelect = undefined,
  alwaysOpen = true,
}) {
  const isControlled = activeKey !== undefined
  const extractedEventKeys = useMemo(() => getAccordionEventKeysFromChildren(children), [children])
  const resolvedDefaultActiveKey = useMemo(() => {
    if (isControlled) {
      return undefined
    }

    if (defaultActiveKey !== undefined) {
      return defaultActiveKey
    }

    return getIntuneAccordionDefaultActiveKeys(extractedEventKeys)
  }, [defaultActiveKey, extractedEventKeys, isControlled])

  return (
    <Accordion
      className={accordionStyles.settingsAccordion}
      {...(isControlled ? { activeKey, onSelect } : { defaultActiveKey: resolvedDefaultActiveKey })}
      alwaysOpen={alwaysOpen}
    >
      {children}
    </Accordion>
  )
}

IntuneEditFormAccordion.propTypes = accordionPropTypes

const itemPropTypes = {
  eventKey: PropTypes.string.isRequired,
  titleMessageId: PropTypes.string,
  title: PropTypes.node,
  children: PropTypes.node,
}

function IntuneEditFormAccordionItem({ eventKey, titleMessageId = null, title = null, children = null }) {
  return (
    <Accordion.Item eventKey={eventKey} className="border-0 bg-transparent">
      <Accordion.Header as="div">
        <span className="text-strong">{title ?? <FormattedMessage id={titleMessageId} />}</span>
      </Accordion.Header>
      <Accordion.Body className="ps-3 pe-0 pb-0">{children}</Accordion.Body>
    </Accordion.Item>
  )
}

IntuneEditFormAccordionItem.propTypes = itemPropTypes

export { IntuneEditFormAccordion, IntuneEditFormAccordionItem }
